<div  *ngIf="ChartData?.length > 0" class="graph" #graph></div>
<div *ngIf="ChartData.length == 0" class="text-center q-c-light-main q-font" ><i class="fas fa-chart-bar"></i> Pas de données à afficher</div>

